/* eslint-disable import/prefer-default-export */

export const RELOAD_REQUESTED = 'RELOAD_REQUESTED';
